// extracted by mini-css-extract-plugin
export default {"bold-text":"analaytics_bold-text__3iPLa","font-size-1":"analaytics_font-size-1__2TSBP","horizontal-scroll":"analaytics_horizontal-scroll__2Wv_t"};